module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="mbx-info text-left">\n    <dl class="stepped zero">\n        <dt>\n            <label for="organization-name">' +
((__t = ( i18next.t('common.name') )) == null ? '' : __t) +
'</label>\n        </dt>\n        <dd>\n            <input class="text" id="organization-name" name="lead[organization_name]" type="text" value="' +
((__t = ( organization_name )) == null ? '' : __t) +
'">\n        </dd>\n\n        <dt>\n            <label for="subdomain">' +
((__t = ( i18next.t('glossary.subdomain') )) == null ? '' : __t) +
'</label>\n        </dt>\n        <dd>\n            <input class="text" id="subdomain" name="lead[subdomain]" type="text">\n        </dd>\n\n        <dt>\n            <label for="country-code">' +
((__t = ( i18next.t('common.country') )) == null ? '' : __t) +
'</label>\n        </dt>\n        <dd>\n            <select class="text" id="country-code" name="lead[country_code]">\n                ';
 allCountries.forEach(function (co){ ;
__p += '\n                    <option value="' +
((__t = ( co.country_code )) == null ? '' : __t) +
'" ' +
((__t = ( co.country_code === country ? 'selected' : '' )) == null ? '' : __t) +
'>\n                        ' +
((__t = ( co.name )) == null ? '' : __t) +
'\n                    </option>\n                ';
 }) ;
__p += '\n            </select>\n        </dd>\n\n        <dt>\n            <label for="timezone">' +
((__t = ( i18next.t('glossary.timezone') )) == null ? '' : __t) +
'</label>\n        </dt>\n        <dd>\n            <select class="text" id="timezone" name="lead[timezone]"></select>\n        </dd>\n\n        <dt>\n            <label for="currency">' +
((__t = ( i18next.t('common.currency') )) == null ? '' : __t) +
'</label>\n        </dt>\n        <dd>\n            <select class="text" id="currency" name="lead[currency]">\n                ';
 allCurrencies.forEach(function (currency){ ;
__p += '\n                    <option value="' +
((__t = ( currency )) == null ? '' : __t) +
'">\n                        ' +
((__t = ( currency )) == null ? '' : __t) +
'\n                    </option>\n                ';
 }) ;
__p += '\n            </select>\n        </dd>\n\n        <dt>\n            <label for="organization-type">' +
((__t = ( i18next.t('common.type') )) == null ? '' : __t) +
'</label>\n        </dt>\n        <dd>\n            <select class="text" id="organization-type" name="lead[organization_type]">\n                ';
 allTypes.forEach(function (type){ ;
__p += '\n                    <option value="' +
((__t = ( type.slug )) == null ? '' : __t) +
'" ' +
((__t = ( type.slug === organization_type ? 'selected' : '' )) == null ? '' : __t) +
'>\n                        ' +
((__t = ( type.name )) == null ? '' : __t) +
'\n                    </option>\n                ';
 }) ;
__p += '\n            </select>\n        </dd>\n\n        <dt>\n            <label for="name">' +
((__t = ( i18next.t('users.name') )) == null ? '' : __t) +
'</label>\n        </dt>\n        <dd>\n            <input class="text" id="name" name="lead[name]" type="text" value="' +
((__t = ( name )) == null ? '' : __t) +
'">\n        </dd>\n\n        <dt>\n            <label for="email">' +
((__t = ( i18next.t('common.email') )) == null ? '' : __t) +
'</label>\n        </dt>\n        <dd>\n            <input class="text" id="email" name="lead[email]" type="text" value="' +
((__t = ( email )) == null ? '' : __t) +
'">\n        </dd>\n\n\n        <dt>\n            <label class=\'decapitalize\' for="logo">' +
((__t = ( i18next.t('organizations.logo_label') )) == null ? '' : __t) +
'</label>\n        </dt>\n        <dd>\n            <input accept=\'image/png\' class=\'input-file text\' type=\'file\' id="organization-logo">\n        </dd>\n        <div class=\'preview-image-wrapper\'>\n            <dt>\n                <label for=\'preview-image\'>' +
((__t = ( i18next.t('common.preview') )) == null ? '' : __t) +
'</label>\n            </dt>\n            <dd class=\'preview\'>\n                <img class=\'preview-image\' id=\'preview-image\' src=\'#\' alt=\'logo\'/>\n            </dd>\n        </div>\n    </dl>\n</div>\n';

}
return __p
}